import React from "react";
import styled from "styled-components";
import { withProps } from "recompose";
import NavLink from "react-router-dom/NavLink";

import Button from "package-common-react/lib/components/Button";
import { get, mixin } from "package-common-react/lib/style/util";

import theme from "../../theme";

export const WinningPanel = styled.div`
  color: ${get("color.red")};
  text-align: center;

  .heading {
    ${mixin("font.bold", 30, 1)};
    color: ${get("color.red")};
    margin: 0.5em 0;
    padding: 0;
    text-transform: uppercase;
  }
  .subheading {
    ${mixin("font.bold", 26, 1)};
    color: ${get("color.primaryText")};
    margin: 0.5em 0;
    padding: 0;
  }
  .text {
    ${mixin("font.default", 18, 1)};
    margin: 0.5em 0;
    padding: 0;
  }
  .legal {
    ${mixin("font.default", 12)};
    color: ${get("color.blue")};
    margin: 0.5em 0;
    padding: 0;
  }
`;
export const LosingPanel = WinningPanel.extend`
`;

export const WinningPanelBlock = styled.div`
  ${mixin("font.default", 20, 1)};
  background: ${get("color.red")};
  border-radius: 8px;
  color: ${get("color.blueText")};
  margin: 20px 0;
  padding: 25px;
  text-align: center;

  strong {
    ${mixin("font.default", 28)};
    display: block;
  }
`;

export const Score = styled.p`
  ${mixin("font.bold", 48, 1)};
  color: ${get("color.successText")};
  margin: 15px 0;
  padding: 0;
  text-align: center;
`;

export const ReplayButton = withProps({ primary: true })(Button);
export const RegistrationButton = styled(
  withProps({
    primary: true,
    backgroundColor: theme.color.redText,
    textColor: theme.color.red
  })(
    Button.withComponent(function({
      primary,
      backgroundColor,
      textColor,
      ...props
    }) {
      return <NavLink {...props} />;
    })
  )
)`
  margin-top: 0.5em;
`;



// WEBPACK FOOTER //
// ./src/components/PlayResults/style.js